import React from 'react';

import goodDogPodLogoJpg from 'dpl/assets/good_dog_pod_logo.jpg';
import spotifyJpg from 'dpl/assets/podcasts/spotify.jpg';
import applePodcastsJpg from 'dpl/assets/podcasts/apple_podcasts.jpg';
import googlePodcastsJpg from 'dpl/assets/podcasts/google_podcasts.jpg';

const TAGS = [
  'Health & Veterinary Care',
  'Legislation',
  'Legal Advocacy',
  'Training & Behavior Science',
  'Breeding Practices'
];

const SERVICES = [
  [
    'Spotify',
    'https://open.spotify.com/show/5MGxiz8lxcEWEwA7Axpxva?si=qsZDzbJGTSas1poTNijn3g',
    spotifyJpg
  ],
  [
    'Apple Podcasts',
    'https://podcasts.apple.com/us/podcast/the-good-dog-pod/id1520232516',
    applePodcastsJpg
  ],
  [
    'Google Podcasts',
    'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5jYXB0aXZhdGUuZm0vdGhlLWdvb2QtZG9nLXBvZA?ved=0CAYQrrcFahcKEwjoicSL8uDqAhUAAAAAHQAAAAAQAQ',
    googlePodcastsJpg
  ]
];

export default function PodcastHeader() {
  return (
    <div className="PrismicPodcastHeader container">
      <div className="flex align-items-center">
        <div className="row">
          <div className="col-lg-5">
            <div className="mb4 mb0-lg tr-l tc">
              <img
                alt="Good Dog Pod logo"
                className="pointer-events-none"
                src={goodDogPodLogoJpg}
              />
            </div>
            <h3 className="mb4 d-lg-none f6">The Good Dog Pod</h3>
          </div>
          <div className="col-lg-7">
            <div className="ph14-xl pl6-lg">
              <p className="mb3 mb6-lg f4 f5-lg fw-medium">
                Supporting dog breeders and responsible dog ownership.
              </p>
              <p className="mb8">
                Good Dog is on a mission to build a better world for our dogs
                and the people who love them by educating the public and
                advocating for dog breeders. The Good Dog Pod will help us
                achieve our mission by providing dog breeders and the public
                with the latest updates in canine health and veterinary care,
                animal legislation and legal advocacy, canine training and
                behavior science, and dog breeding practices.
              </p>
              <p className="fw-medium mb5">
                In this podcast you&apos;ll hear about:
              </p>
              <div className="f0 nv1 nh1">
                {TAGS.map(tag => (
                  <span
                    key={tag}
                    className="pv2 ph4  br2 mv1 mh1 dib fw-medium f2 ttu blue bg-black-05"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="mt8 pb22">
                <p className="fw-medium mb5">
                  Subscribe now, wherever you listen to podcasts:
                </p>
                <div className="nh1 flex">
                  {SERVICES.map(([name, url, imageUrl]) => (
                    <a
                      className="pv3 ph4 ba b--moon-gray br2 mb2 mh1 inline-flex bg-white"
                      href={url}
                      key={name}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="flex align-items-center">
                        <img alt={`${name} logo`} src={imageUrl} />
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
